import { API_STAGES } from "@redux/create-api-module";
import { $ApiModuleName, TApiAction } from "@redux/store.types";

import { TApiErrorsState } from "./errors.types";

// https://medium.com/stashaway-engineering/react-redux-tips-better-way-to-handle-loading-flags-in-your-reducers-afda42a804c6

const ApiErrorsReducer = (
    state: TApiErrorsState = {},
    action: TApiAction<string>,
) => {
    const { type } = action;
    const matches = /(.*)\/(.*)\/(pending|success|failure|reset)/.exec(type);

    if (!matches) return state;

    const [, prefix, requestName, requestState] = matches;
    if (prefix !== $ApiModuleName) {
        return state;
    }

    return {
        ...state,
        [requestName]:
            requestState === API_STAGES.Failure.toLowerCase() ? action.payload : undefined,
    };
};

export default ApiErrorsReducer;
